import { Directive, ElementRef, booleanAttribute, computed, effect, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatTooltip } from '@angular/material/tooltip';
import { SafeHtml } from '@angular/platform-browser';
import { PassDataService } from 'src/app/shared/services/pass-data/pass-data.service';
import { PlatformService } from 'src/app/shared/services/platform.service';

// One action of a table row, projected into urban-row-actions: inline icon on
// desktop, entry of the row menu on a phone unless it is the only secondary
// one. The primary action also becomes the tap target of the whole row there
// (styles.scss, table.uvMobileList).
@Directive({
  selector: 'button[urbanRowAction]',
  standalone: false,
  hostDirectives: [MatTooltip],
  host: {
    type: 'button',
    '[class.iconInfoButton]': '!warn()',
    '[class.iconDeleteButton]': 'warn()',
    '[class.rowActionPrimary]': 'primary()',
    '[attr.aria-label]': 'label()',
    '[innerHTML]': 'svg()'
  }
})
export class RowActionDirective {
  readonly icon = input.required<string>({ alias: 'urbanRowAction' });
  readonly label = input.required<string>();
  readonly primary = input(false, { transform: booleanAttribute });

  readonly warn = computed<boolean>(() => this.icon() === 'delete');
  readonly svg = computed<SafeHtml>(() => this.icons()[this.icon()] ?? '');

  private readonly host: HTMLButtonElement = inject(ElementRef).nativeElement;
  private readonly icons = toSignal(inject(PassDataService).sanIcons$, { initialValue: {} as Record<string, SafeHtml> });

  constructor() {
    const tooltip = inject(MatTooltip);
    const isMobile = inject(PlatformService).isMobileViewport;

    effect(() => {
      tooltip.message = this.label();
      tooltip.disabled = isMobile();
    });
  }

  trigger(): void {
    this.host.click();
  }
}
